const SEND_EMAIL_ENDPOINT = "/api/send-email";

export const sendEmailWithValues = async (
  values: Object,
  TEMPLATE_ID: string
) => {
  const res = await fetch(SEND_EMAIL_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ template: TEMPLATE_ID, ...values }),
  });
  if (!res.ok) {
    throw new Error(`Failed to send email (${res.status})`);
  }
};

export const fileToBase64 = (file: File): Promise<string | ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
